import React from "react";

const PageFooterDivider = () => {
  return <div className="meeting6ix-layout-footer-divider"></div>;
};

export default PageFooterDivider;
